module.exports = __webpack_public_path__ + "img/wide.9504e78d.jpg";